import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import { Link } from 'gatsby'
import { Section } from '..'
import * as styles from './styles'
import variables from '../../styles/variables'

const propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  color: PropTypes.string,
  imgLink: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired
}

const defaultProps = {
  color: variables.colors.jade.medium
}

export default function PopularUseCaseCard(props) {
  const {
    path, title, description, color, imgLink, imgAlt
  } = props
  return (
    <styles.Container>
      <Link to={path} style={{ textDecoration: 'none' }}>
        <styles.Card color={color}>
          <Row>
            <Col md={6} sm={12} xs={12}>
              <styles.CardHeader>{title}</styles.CardHeader>
              <styles.Introduction>
                {description}
              </styles.Introduction>
            </Col>
            <Section>
              <Col md={6} sm={12} xs={12}>
                <styles.UseCaseImgContainer>
                  <styles.UseCaseImg src={imgLink} alt={imgAlt} height="100px" />
                </styles.UseCaseImgContainer>
              </Col>
            </Section>
          </Row>
          <styles.LinkRow>
            Read more
            <styles.Chevron />
          </styles.LinkRow>
        </styles.Card>
      </Link>
    </styles.Container>
  )
}

PopularUseCaseCard.propTypes = propTypes
PopularUseCaseCard.defaultProps = defaultProps
